import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { BankAccountCreationFormWrapper } from 'src/Components/Forms/BankAccount/BankAccountCreationFormWrapper';

const CreateBankAccountDrawer = () => {
  const { t } = useTranslation();

  return (
    <AnimatedRoutedDrawer
      title={t('bankAccounts.drawer.createTitle', 'Ajouter un compte bancaire')}
    >
      {({ onClose }) => <BankAccountCreationFormWrapper onCancel={onClose} onCreate={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateBankAccountDrawer;
